export const navOverAll = {
    padding: "0"
};
export const navStyle = {
    display: "flex"
};

export const subNavStyle = {
    height: "40px",
    position: "absolute",
    width: "100%",
    zIndex: "4",
    visibility: "visible"
};

export const subNavShow = {
    visibility: "visible"
};

export const subNavHidden = {
    visibility: "hidden"
};

export const navTitle = {
    fontSize: "1.5rem",
    padding: "0.5rem 1rem",
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "#163172",
    color: "white",
    cursor: "pointer"
};

export const navPod = {
    fontSize: "1.5rem",
    padding: "0.5rem 1rem",
    textAlign: "right",
    backgroundColor: "#1e56a0",
    color: "white"
};

export const navDropdown = {
    backgroundColor: "#1e56a0"
};

export const columnWidthTitle = {
    fontSize: "1.5rem",
    padding: "0.5rem 1rem",
    textAlign: "right",
    backgroundColor: "#1e56a0",
    color: "white"
};

export const membershipTitle = {
    fontSize: "1.5rem",
    padding: "0.5rem 1rem",
    textAlign: "right",
    backgroundColor: "#1e56a0",
    color: "yellow"
};

export const columnWidth = {
    fontSize: "1.5rem",
    textAlign: "left",
    backgroundColor: "#1e56a0",
    color: "white"
};

export const navLink = {
    backgroundColor: "#1e56a0",
    color: "white",
    textAlign: "center",
    fontSize: "1.5rem"
};

export const subNavLink = {
    backgroundColor: "#d6e4f0",
    color: "#163172",
    textAlign: "center",
    fontSize: "1.1rem",
    height: "40px",
    paddingTop: "10px"
};

export const subNavLRBorders = {
    borderLeft: "solid 1px black",
    borderRight: "solid 1px black"
};

export const subNavBottom = {
    borderBottom: "solid 1px black"
};

export const visible = {
    visibility: "visible"
};

export const hidden = {
    visibility: "hidden"
};
